export const tooltipSizeTypes = {
    default: '',
    large: 'gfu-tooltip__balloon--large',
};
